var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFace = function SvgFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.2 10a6.8 6.8 0 1 1 13.6 0 6.8 6.8 0 0 1-13.6 0M10 1.8a8.2 8.2 0 1 0 0 16.4 8.2 8.2 0 0 0 0-16.4M7.813 11.874a.7.7 0 0 0-.626 1.252 6.29 6.29 0 0 0 5.626 0 .7.7 0 1 0-.626-1.252 4.89 4.89 0 0 1-4.374 0M6.6 8.25a.9.9 0 0 1 .9-.9h.008a.9.9 0 0 1 0 1.8H7.5a.9.9 0 0 1-.9-.9m5.9-.9a.9.9 0 1 0 0 1.8h.008a.9.9 0 1 0 0-1.8z",
    clipRule: "evenodd"
  })));
};
export default SvgFace;